import {formFieldConfigs} from './formFields';
import {tableColumnConfigs} from './tableColumns';
import {API_PATHS} from '@/api/paths';

export const pageConfigs = {
    // banner 列表配置
    bannerList: {
        apiPath: API_PATHS.BANNER_LIST,
        formFields: [
            {key: 'position', config: formFieldConfigs.positionSelect},
            {key: 'status', config: formFieldConfigs.statusSelect},
            {key: 'keyword', config: formFieldConfigs.keywordSearch},
            {key: 'actions', config: formFieldConfigs.actionButtons}
        ],
        tableColumns: [
            {key: 'index', config: tableColumnConfigs.index},
            {key: 'number', config: tableColumnConfigs.number},
            {key: 'title', config: tableColumnConfigs.title},
            {key: 'location', config: tableColumnConfigs.location},
            {key: 'start_at', config: tableColumnConfigs.startAt},
            {key: 'end_at', config: tableColumnConfigs.endAt},
            {key: 'last_page', config: tableColumnConfigs.lastPage},
            {key: 'status', config: tableColumnConfigs.status},
            {key: 'publish', config: tableColumnConfigs.publishStatus},
            {key: 'actions', config: tableColumnConfigs.baseActions}
        ]
    },

    // banner 分类配置
    bannerClassList: {
        apiPath: API_PATHS.BANNER_CLASS_LIST,
        formFields: [
            {key: 'status', config: formFieldConfigs.statusSelect},
            {key: 'keyword', config: formFieldConfigs.keywordSearch},
            {key: 'actions', config: formFieldConfigs.actionButtons}
        ],
        tableColumns: [
            {key: 'index', config: tableColumnConfigs.index},
            {key: 'name', config: tableColumnConfigs.name},
            {key: 'alias', config: tableColumnConfigs.alias},
            {key: 'info', config: tableColumnConfigs.info},
            {key: 'status', config: tableColumnConfigs.status},
            {key: 'actions', config: tableColumnConfigs.baseActions}
        ]
    },

       // aspect-ratio 横幅宽高比配置
       bannerAspectRatioList: {
        apiPath: API_PATHS.BANNER_ASPECT_RATIO_LIST,
        formFields: [
            {key: 'platform', config: formFieldConfigs.platformSelect},
            {key: 'status', config: formFieldConfigs.statusSelect},
            {key: 'keyword', config: formFieldConfigs.keywordSearch},
            {key: 'actions', config: formFieldConfigs.actionButtons}
        ],
        tableColumns: [
            {key: 'index', config: tableColumnConfigs.index},
            { key: 'number', config: tableColumnConfigs.number },
            {key: 'platform', config: tableColumnConfigs.platform},
            {key: 'aspect_ratio_key', config: tableColumnConfigs.aspect_ratio_key},
            {key: 'width', config: tableColumnConfigs.width},
            {key: 'height', config: tableColumnConfigs.height},
            {key: 'status', config: tableColumnConfigs.status},
            {key: 'actions', config: tableColumnConfigs.baseActions}
        ]
    }
};
